import React from "react";
import ContentLoader from "react-content-loader";

export default props =>{
    return <ContentLoader 
        speed={1} 
        viewBox="0 0 400 600"
    >
        <rect x="12" y="10" width="378" height="30" />
        <rect x="12" y="50" width="378" height="30" rx="15" />
        <rect x="12" y="90" width="378" height="30" />
        <rect x="12" y="130" width="378" height="30" rx="15" />
        <rect x="12" y="170" width="378" height="30" />
        <rect x="12" y="210" width="378" height="30" rx="15" />
        <rect x="12" y="250" width="378" height="30" />
        <rect x="12" y="290" width="378" height="30" rx="15" />
        <rect x="12" y="330" width="378" height="30" />
        <rect x="12" y="370" width="378" height="30" rx="15" />
        <rect x="12" y="410" width="378" height="30" />
        <rect x="12" y="450" width="378" height="30" rx="15" />
        <rect x="12" y="490" width="378" height="30" />
        <rect x="12" y="530" width="378" height="30" rx="15" />
        <rect x="12" y="570" width="378" height="30" />
        <rect x="12" y="610" width="378" height="30" rx="15" />
    </ContentLoader>
}